import axios from '@/plugins/axios' 

const stateUser = {
  currentUser: {
    id: localStorage.getItem('id'),
    nombres: localStorage.getItem('nombres'),
    aPaterno: localStorage.getItem('aPaterno'),
    aMaterno: localStorage.getItem('aMaterno'),
    NombresApaterno: localStorage.getItem('NombresApaterno'),
    email: localStorage.getItem('email'),
    codAge: localStorage.getItem('codAge'),
    menu: localStorage.getItem('menu'),
  },
  acceptcookie: localStorage.getItem('acceptcookie'),
  token:
    localStorage.getItem('token') != null
      ? localStorage.getItem('token')
      : sessionStorage.getItem('token'),
  id: 0,
  idTarjetaTxt: localStorage.getItem('idTarjetaTxt'),
  idTarjeta: localStorage.getItem('idTarjeta'),
}

const gettersUser = {
  getName: (state) => `${state.currentUser.nombres}`,
  getApellidos: (state) => `${state.currentUser.aPaterno}`,
  getEmail: (state) => state.currentUser.email,
  isLogged: (state) => !!(state.token),
  getIDE: (state) => state.currentUser.id,
  getCookie: (state) => !!(state.acceptcookie),
  getCODAGE: (state) => state.currentUser.codAge,
  getMenuOpcions: (state) => state.currentUser.menu,
  getIdTarjetaTxt: (state) => state.idTarjetaTxt,
  getIdTarjeta: (state) => state.idTarjeta,
  getNombresApaterno: (state) => state.currentUser.NombresApaterno
}

const mutationsUser = {
  ACCEPT_COOKIE(state, acceptcookie) {
    localStorage.setItem('acceptcookie', `${acceptcookie}`)
    state.acceptcookie = acceptcookie
  },
  LOGIN_USER(state, userData) {
    const nombresApaterno = `${userData.nombres} ${userData.aPaterno}`;

    localStorage.setItem('id', userData.id)
    localStorage.setItem('nombres', `${userData.nombres}`)
    localStorage.setItem('aPaterno', userData.aPaterno)
    localStorage.setItem('aMaterno', userData.aMaterno)
    localStorage.setItem('NombresApaterno',  nombresApaterno)
    localStorage.setItem('email', `${userData.email}`)
    localStorage.setItem('token', userData.token)
    localStorage.setItem('codAge', userData.codAge)
    localStorage.setItem('menu', userData.menu)
    localStorage.setItem('idTarjetaTxt', userData.idTarjetaTxt)
    localStorage.setItem('idTarjeta', userData.idTarjeta)

    state.currentUser.id = userData.id
    state.currentUser.nombres = userData.nombres
    state.currentUser.aPaterno = userData.aPaterno
    state.currentUser.aMaterno = userData.aMaterno
    state.currentUser.NombresApaterno = nombresApaterno
    state.currentUser.email = userData.email
    state.currentUser.token = userData.token
    state.currentUser.codAge = userData.codAge
    state.currentUser.menu = userData.menu
    state.idTarjetaTxt = userData.idTarjetaTxt
    state.idTarjeta = userData.idTarjeta
  },
  LOGOUT_USER() {
    localStorage.removeItem('id')
    localStorage.removeItem('token')
    localStorage.removeItem('nombres')
    localStorage.removeItem('aPaterno')
    localStorage.removeItem('aMaterno')
    localStorage.removeItem('NombresApaterno')
    localStorage.removeItem('email')
    localStorage.removeItem('codAge')
    localStorage.removeItem('menu')
    localStorage.removeItem('idTarjetaTxt')
    localStorage.removeItem('idTarjeta')
  }
}

const actions = {
  async login({ commit }, credentials) { 
    const response = await axios.post('/Auth', credentials);
    commit('LOGIN_USER', response.data)
    localStorage.setItem('tipoUsuario', credentials.tipo);
    
    return response.data.url; // o cualquier ruta válida
  },
  async iniciosesion({ commit }, credentials) {
    return await axios.post('/Auth/user', credentials).then(({ data }) => {
      if (data) {
        commit('LOGIN_USER', data)
        return data.url
      }
    }).catch(error => {
      console.error('Error en la solicitud:', error);
      throw error;
    });
  },
  logout({ commit }) {
    commit('LOGOUT_USER')
  }

}

export default {
  state: stateUser,
  mutations: mutationsUser,
  getters: gettersUser,
  actions
}
